import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import SavingsBar from '../components/SavingsBar';
import VideoSection from '../components/VideoSection';
import AudienceSection from '../components/AudienceSection';
import Listings from '../components/Listings';
import HomeEstimator from '../components/HomeEstimator';
import SellingProcess from '../components/SellingProcess';
import SavingsCalculator from '../components/SavingsCalculator';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection';
import NewsletterSignup from '../components/NewsletterSignup';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';
import { AIChatWidget } from '@/components/ui/ai-chat-widget';

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <div>
        <Hero />
        <SavingsBar />
        <VideoSection />
        <AudienceSection />
        <Listings />
        <HomeEstimator />
        <SellingProcess />
        <SavingsCalculator />
        <Features />
        <Testimonials />
        <BlogSection />
        <NewsletterSignup />
        <FinalCTA />
        <Footer />
      </div>
      
      <AIChatWidget
        title="REALV3 Guide"
        badgeText="Community Support"
        quickPrompts={[
          "How does REALV3 work?",
          "How do I list my home?",
          "How do I search for homes?",
        ]}
        edgeFunction="chat"
        placeholder="Questions about buying or selling with REALV3?"
      />
    </div>
  );
};

export default Index;
